<button
  (click)="click()"
  class="block w-full text-left px-4 py-2 text-sm leading-5 text-fg-subtle hover:bg-surface-hover hover:text-fg-primary focus:outline-none focus:bg-surface-hover focus:text-fg-primary"
  role="menuitem"
>
  <ng-content></ng-content>
</button>
